import type { ChangeEvent, ReactNode } from 'react';

//Third Party Libraries

import TableFooter from './TableFooter';
import TableHead from './TableHead';

export default function Table({
  tableHead,
  children,
  currentPage,
  totalPage,
  perPage,
  perPageHandler,
  pageChangeHandler,
  handleBulkSelected,
  isBulkSelected,
}: {
  tableHead: string[];
  children: ReactNode;
  currentPage: number;
  totalPage: number;
  perPage?: number;
  perPageHandler: (v: ChangeEvent<HTMLSelectElement>) => void;
  pageChangeHandler: (direction: string) => void;
  handleBulkSelected?: (selected: boolean) => void;
  isBulkSelected?: boolean;
}) {
  return (
    <div className='shadow border-b border-gray-200 sm:rounded-lg overflow-x-scroll'>
      <table className='w-full divide-y divide-gray-200'>
        <TableHead headers={tableHead} handleBulkSelected={handleBulkSelected} isBulkSelected={isBulkSelected} />
        <tbody className='bg-white divide-y divide-gray-200'>{children}</tbody>
      </table>
      <TableFooter
        totalPage={totalPage}
        currentPage={currentPage}
        perPage={perPage}
        perPageHandler={perPageHandler}
        pageChangeHandler={pageChangeHandler}
      />
    </div>
  );
}
